import { base64UrlToBytes, bytesToBase64Url, randomBytes, utf8Decode, utf8Encode } from './encoding';

export interface EncryptedBlob {
  /** Base64url-encoded 12-byte IV. */
  iv: string;
  /** Base64url-encoded ciphertext (includes the 16-byte GCM auth tag at the tail). */
  ct: string;
}

export function isEncryptedBlob(value: unknown): value is EncryptedBlob {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as { iv?: unknown }).iv === 'string' &&
    typeof (value as { ct?: unknown }).ct === 'string'
  );
}

export async function encryptField(aesKey: CryptoKey, plaintext: string): Promise<EncryptedBlob> {
  const iv = randomBytes(12);
  const ctBuf = await crypto.subtle.encrypt({ name: 'AES-GCM', iv }, aesKey, utf8Encode(plaintext));
  return {
    iv: bytesToBase64Url(iv),
    ct: bytesToBase64Url(new Uint8Array(ctBuf)),
  };
}

export async function decryptField(aesKey: CryptoKey, blob: EncryptedBlob): Promise<string> {
  const iv = base64UrlToBytes(blob.iv);
  const ct = base64UrlToBytes(blob.ct);
  const ptBuf = await crypto.subtle.decrypt({ name: 'AES-GCM', iv }, aesKey, ct);
  return utf8Decode(new Uint8Array(ptBuf));
}
